
/**
 * 뉴스 내용 정보
 */
export type ExploreContentResponsePageAllOfThreeContentItemContentOneOfFivezeroContent = {
  summary?: string;
};
